import get from 'lodash.get';

const getUserEmails = (rootState) => get(rootState, 'ws.site.meta.settings.emails', null);

export default getUserEmails;
